import { request } from "../../utils/config"

/*
  Tovar (yoki kategoriya) bo'yicha alohida KPI qoidalari.

  Helpers/KPI — to'lov turi bo'yicha umumiy sozlama (butun tizimga bir xil).
  Helpers/KPIRules — aniq tovarga bog'langan qoidalar: shu tovar sotilsa,
  undan qolgan toza foydaning belgilangan foizi menejerga yoziladi.
*/

const auth = () => ({
  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
})

export const GET_KPI_RULES = async () => {
  const response = await request({
    url: `Helpers/KPIRules`,
    method: "GET",
    headers: auth(),
  })
  return response.data
}

export const CREATE_KPI_RULE = async (data: any) => {
  const response = await request({
    url: `Helpers/KPIRules`,
    method: "POST",
    data,
    headers: auth(),
  })
  return response.data
}

export const UPDATE_KPI_RULE = async (data: any) => {
  const response = await request({
    url: `Helpers/KPIRules`,
    method: "PUT",
    data,
    headers: auth(),
  })
  return response.data
}

export const DELETE_KPI_RULE = async (id: number) => {
  const response = await request({
    url: `Helpers/KPIRules`,
    method: "DELETE",
    params: { id },
    headers: auth(),
  })
  return response.data
}
